import { normalizeExcelFilename } from './report-export-file-name.utils';
import type { ReportExportFileService } from './report-export-file.service';

export class WebReportExportFileService implements ReportExportFileService {
  async saveExcelFile(buffer: ArrayBuffer | BlobPart, filename: string): Promise<void> {
    const blob =
      buffer instanceof Blob
        ? buffer
        : new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });

    const finalFilename = normalizeExcelFilename(filename);
    const hasDownloadAttribute = 'download' in HTMLAnchorElement.prototype;
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = finalFilename;
    link.rel = 'noopener';
    link.style.display = 'none';

    document.body.appendChild(link);
    link.click();

    if (!hasDownloadAttribute) {
      window.open(url, '_blank', 'noopener');
    }

    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1_000);
  }
}
